import { Grid } from "@mui/material";
import React, { useState, useEffect } from "react";
import { useAlertContext } from "src/hooks/use-alert";
import "src/components/Testing/testing.css";
import moment from "moment";
import ReportProblemIcon from "@mui/icons-material/ReportProblem";
import Alert from "@mui/material/Alert";
import AppSettingsAltIcon from "@mui/icons-material/AppSettingsAlt";
import {
  useNavigate,
  useRouteLoaderData,
  defer,
  Await,
} from "react-router-dom";
import { getAllAlarms } from "src/apis/tickets";
const ticketStatuses = ["Open", "In progress", "Pending approval", "Closed"];
const AlertCard = ({ alert }) => {

  let severityColor = "";
  let borderColor = "";
  let icon = <ReportProblemIcon />; // default icon
  let phrase = "";
  switch (alert.impactType) {
    case "ALARM":
      switch (alert.ticketStatus) {
        case 1:
          severityColor = "blinking-red";
          borderColor = "red";
          break;
        case 2:
          severityColor = "redAlert";
          borderColor = "red";
          break;
        case 3:
          severityColor = "yellowAlert";
          borderColor = "yellow";
          break;
        case 4:
          severityColor = "greenAlert";
          borderColor = "green";
          break;

        default:
          break;
      }
      break;

    case "WARNING":
      switch (alert.ticketStatus) {
        case 4:
          severityColor = "greenAlert";
          borderColor = "green";
          break;
        default:
          severityColor = "yellowAlert";
          borderColor = "yellow";
          break;
      }
      break;
    case "AI":
      severityColor = "aiAlert";
      borderColor = "aiBorder";
      icon = <AppSettingsAltIcon />; // use AppSettingsAltIcon for aiPrediction
      phrase = "AI Prediction:";
      break;

    default:
      break;
  }
  const alertStyle = {
    borderColor: borderColor,
  };

  return (
    <div className={`alert-card ${borderColor}`}>
      <div className="alertCardContent">
        <Alert severity="error">
          <h2 className={`${severityColor}`}>
            {icon} {phrase} {alert.itemSnAssociated}
          </h2>
        </Alert>
        <h3 className={`${severityColor}`}>Asset: {alert.assetSnAssociated}</h3>
        <p style={{ color: "#FFF" }}>Severity: {alert.impactName}</p>
        <p style={{ color: "#FFF" }}>Ticket Situation: {ticketStatuses[alert.ticketStatus - 1]}</p>
        <p style={{ color: "#FFF" }}> Occurrence date: {moment(alert.date).format("YYYY-MM-DD - HH:mm:ss")}</p>
        <p style={{ color: "#FFF" }}>Being Resolved by : {alert.mnt_operator_email}</p>
      </div>
    </div>
  );
};

const AlertGrid = ({ alerts }) => (
  // Assuming you have an array of objects called 'data' with a 'statusDate' property
  <Grid container className="alert-grid" height={'90%'}>
    {alerts.map((alert) => (
      <Grid key={alert.id} item xs={12} sm={6} md={6} lg={4} xl={3}>
        <AlertCard alert={alert} />
      </Grid>
    ))}
  </Grid>
);

const AlertSearch = ({ alerts, setSearchResults,defaultResults }) => {
  // const [searchQuery, setSearchQuery] = useState("");
  // //const searchQuery = e.target.value.toLowerCase();
  
  const handleSearch = (e) => {
    const searchQuery = e.target.value.toLowerCase();
    if(searchQuery!==""){
    const results = alerts.filter(
      (alert) =>
        alert.itemSnAssociated.toLowerCase().includes(searchQuery) ||
        alert.impactName.toLowerCase().includes(searchQuery)
    );
    setSearchResults(results);}
    else if (searchQuery ===""){
      setSearchResults(defaultResults)
    }
  };

  return (
    <div className="alert-search">
      <input
        type="text"
        placeholder="Search alerts..."
        onChange={handleSearch}
      />
    </div>
  );
};

const AlertApp = () => {
  const alert = useAlertContext();
  const fetchAlarms = async () => {
    await getAllAlarms().then((res) => {
      if (res && res.length>0) {
        const dateSortedAlarms = res.sort(
          (a, b) => -(new Date(a.date) - new Date(b.date))
        );
        setAlarms_(dateSortedAlarms);
        setDefaultResults(dateSortedAlarms);
      }
    });
  };




  const [alerts, setAlerts] = useState([]);
  const [alarms_, setAlarms_] = useState([]);
  useEffect(() => {
    if (alert.alarmPageUpdate) { //causes to refetch all alarms page after reception of alarm in socket
      const timeoutId = setTimeout(() => {
        fetchAlarms();
      }, 900); 
     
      alert.setAlarmPageUpdate(false)
    } // fetch new alarms 

    if (alert.ticketUpdate) {
      const newState = alarms_.map(obj => {
        // 👇️ if Ticketid of corresponding alarm equals id in event, update actual status property
        if (obj.fatherId === parseInt(alert.ticketUpdate.fatherId)) {
          const index = parseInt(alert.ticketUpdate.status)
          return { ...obj, ticketStatus: index };
        }
        return obj;
      });
      setAlarms_(newState);
    } //update alarm status if its corresponding ticket is updated


  }, [alert.alarmPageUpdate, alert.ticketUpdate]);

  const [searchResults, setSearchResults] = useState([]);
  const [defaultResults, setDefaultResults] = useState([]);
  const [orderedTickets, setOrderedTickets] = useState([]);
  
  useEffect(() => {
    fetchAlarms();
  }, []);

  useEffect(() => {
    setSearchResults(alarms_);
  }, [alarms_]);

 
  return (
    <Grid container className="alert-app">
      <Grid item md={12} height={"10%"}>
        <AlertSearch alerts={alarms_} setSearchResults={setAlarms_} defaultResults={alarms_} />
      </Grid>
      <AlertGrid alerts={alarms_} />

    </Grid>
  );
};

export default AlertApp;
